export const registerMessageTypes = {
  AccountExist: 'AccountExist',
  DuplicateMobile: 'DuplicateMobile',
  EditSejamData: 'EditSejamData',
  // Message types for shahkar bottomsheet
  Shahkar: 'Shahkar',
  ShahkarNotMatched: 'ShahkarNotMatched',
  // Message types for ekyc pending bottomsheet
  PendingValidation: 'PendingValidation',
  PendingEkyc: 'PendingEkyc',
  // Message types for ekyc approval bottomsheet
  FailedEkyc: 'FailedEkyc',
  RejectEkyc: 'RejectEkyc',
};

export const ekycApprovalMessageTypes = [
  registerMessageTypes?.RejectEkyc,
  registerMessageTypes?.FailedEkyc,
];

export const ekycPendingMessageTypes = [
  registerMessageTypes?.PendingValidation,
  registerMessageTypes?.PendingEkyc,
];

export const shahkarMessageTypes = [
  registerMessageTypes?.Shahkar,
  registerMessageTypes?.ShahkarNotMatched,
];
